const tagIcons = [
  {
    name: 'Business',
    icons: [
      'business_Growup.svg',
      'business_Successful.svg',
      'business_advisor.svg',
      'business_agreement1.svg',
      'business_agreement2.svg',
      'business_analytic1.svg',
      'business_analytic2.svg',
      'business_brainstorming.svg',
      'business_briefcase.svg',
      'business_cashflow.svg',
      'business_consumer.svg',
      'business_contract.svg',
      'business_corporation.svg',
      'business_deadline.svg',
      'business_decision.svg',
      'business_employee.svg',
      'business_finance.svg',
      'business_financial.svg',
      'business_globalconnection.svg',
      'business_googleshopping.svg',
      'business_ideas.svg',
      'business_income.svg',
      'business_investment.svg',
      'business_investor.svg',
      'business_newproject.svg',
      'business_newsreport.svg',
      'business_onlinemeeting.svg',
      'business_opportunity.svg',
      'business_organization.svg',
      'business_partnership.svg',
      'business_piechart.svg',
      'business_presentation.svg',
      'business_projectmanagement.svg',
      'business_report.svg',
      'business_reporting.svg',
      'business_research.svg',
      'business_researchanddevelopment.svg',
      'business_servicecall.svg',
      'business_strategicplan.svg',
      'business_strategy.svg',
      'business_success.svg',
      'business_target1.svg',
      'business_target2.svg',
      'business_target3.svg',
      'business_tax.svg',
      'business_teamwork.svg',
      'business_timemanagement.svg',
      'business_trade.svg'
    ]
  },
  {
    name: 'Contacts',
    icons: [
      'Contacts_24hours.svg',
      'Contacts_bell.svg',
      'Contacts_book1.svg',
      'Contacts_book2.svg',
      'Contacts_browser1.svg',
      'Contacts_browser2.svg',
      'Contacts_browser3.svg',
      'Contacts_browser4.svg',
      'Contacts_browser5.svg',
      'Contacts_browser6.svg',
      'Contacts_businesscard.svg',
      'Contacts_button.svg',
      'Contacts_calendar.svg',
      'Contacts_call1.svg',
      'Contacts_call2.svg',
      'Contacts_call3.svg',
      'Contacts_call4.svg',
      'Contacts_call5.svg',
      'Contacts_call6.svg',
      'Contacts_call7.svg',
      'Contacts_callcenter.svg',
      'Contacts_callvideo1.svg',
      'Contacts_callvideo2.svg',
      'Contacts_callvideo3.svg',
      'Contacts_callvideo4.svg',
      'Contacts_chat1.svg',
      'Contacts_chat2.svg',
      'Contacts_contactform.svg',
      'Contacts_email1.svg',
      'Contacts_error.svg',
      'Contacts_faq.svg',
      'Contacts_fax.svg',
      'Contacts_feedback1.svg',
      'Contacts_feedback2.svg',
      'Contacts_feedback3.svg',
      'Contacts_headphones.svg',
      'Contacts_information.svg',
      'Contacts_laptop.svg',
      'Contacts_letter.svg',
      'Contacts_location1.svg',
      'Contacts_location2.svg',
      'Contacts_location3.svg',
      'Contacts_location4.svg',
      'Contacts_message1.svg',
      'Contacts_message10.svg',
      'Contacts_message11.svg',
      'Contacts_message12.svg',
      'Contacts_message13.svg',
      'Contacts_message14.svg',
      'Contacts_message2.svg',
      'Contacts_message3.svg',
      'Contacts_message4.svg',
      'Contacts_message5.svg',
      'Contacts_message6.svg',
      'Contacts_message7.svg',
      'Contacts_message8.svg',
      'Contacts_message9.svg',
      'Contacts_online.svg',
      'Contacts_page.svg',
      'Contacts_phone1.svg',
      'Contacts_phone10.svg',
      'Contacts_phone11.svg',
      'Contacts_phone12.svg',
      'Contacts_phone13.svg',
      'Contacts_phone2.svg',
      'Contacts_phone3.svg',
      'Contacts_phone4.svg',
      'Contacts_phone5.svg',
      'Contacts_phone6.svg',
      'Contacts_phone7.svg',
      'Contacts_phone8.svg',
      'Contacts_phone9.svg',
      'Contacts_phonemobile1.svg',
      'Contacts_phonemobile2.svg',
      'Contacts_phonemobile3.svg',
      'Contacts_phonemobile4.svg',
      'Contacts_question.svg',
      'Contacts_settings.svg',
      'Contacts_sign.svg',
      'Contacts_target.svg'
    ]
  },
  {
    name: 'Dental',
    icons: [
      'Dental_Bag1.svg',
      'Dental_Calendar3.svg',
      'Dental_Decay1.svg',
      'Dental_Dentistchair5.svg',
      'Dental_Drugs1.svg',
      'Dental_Drugs2.svg',
      'Dental_Drugs3.svg',
      'Dental_Infection1.svg',
      'Dental_Infection2.svg',
      'Dental_Missing.svg',
      'Dental_Mouth1.svg',
      'Dental_Mouth3.svg',
      'Dental_Phone.svg',
      'Dental_alcohol.svg',
      'Dental_analysis.svg',
      'Dental_anesthesia1.svg',
      'Dental_anesthesia2.svg',
      'Dental_anesthesia3.svg',
      'Dental_anesthesia4.svg',
      'Dental_apple.svg',
      'Dental_assistance.svg',
      'Dental_bacteria1.svg',
      'Dental_bacteria2.svg',
      'Dental_badbreath1.svg',
      'Dental_badbreath2.svg',
      'Dental_bag2.svg',
      'Dental_bag3.svg',
      'Dental_bill.svg',
      'Dental_braces1.svg',
      'Dental_braces10.svg',
      'Dental_braces2.svg',
      'Dental_braces3.svg',
      'Dental_braces4.svg',
      'Dental_braces5.svg',
      'Dental_braces6.svg',
      'Dental_braces7.svg',
      'Dental_braces8.svg',
      'Dental_braces9.svg',
      'Dental_brokentooth1.svg',
      'Dental_brokentooth2.svg',
      'Dental_brokentooth3.svg',
      'Dental_calcium.svg',
      'Dental_calendar1.svg',
      'Dental_calendar2.svg',
      'Dental_call1.svg',
      'Dental_call2.svg',
      'Dental_call3.svg',
      'Dental_canine.svg',
      'Dental_cap.svg',
      'Dental_capsule1.svg',
      'Dental_capsule2.svg',
      'Dental_carbide.svg',
      'Dental_care1.svg',
      'Dental_care2.svg',
      'Dental_care3.svg',
      'Dental_care4.svg',
      'Dental_care5.svg',
      'Dental_care6.svg',
      'Dental_care7.svg',
      'Dental_care8.svg',
      'Dental_caries1.svg',
      'Dental_caries2.svg',
      'Dental_caries3.svg',
      'Dental_cavity.svg',
      'Dental_cavity4.svg',
      'Dental_certificate.svg',
      'Dental_chat.svg',
      'Dental_checkup1.svg',
      'Dental_checkup2.svg',
      'Dental_checkup3.svg',
      'Dental_checkup4.svg',
      'Dental_checkup5.svg',
      'Dental_chewinggum1.svg',
      'Dental_chewinggum2.svg',
      'Dental_chipped.svg',
      'Dental_clamp.svg',
      'Dental_cleaning1.svg',
      'Dental_cleaning2.svg',
      'Dental_clinic1.svg',
      'Dental_clinic2.svg',
      'Dental_clipboard.svg',
      'Dental_compare.svg',
      'Dental_computer1.svg',
      'Dental_computer2.svg',
      'Dental_computer3.svg',
      'Dental_computer4.svg',
      'Dental_computer5.svg',
      'Dental_cracked.svg',
      'Dental_crown1.svg',
      'Dental_crown2.svg',
      'Dental_crown3.svg',
      'Dental_crown4.svg',
      'Dental_crown5.svg',
      'Dental_crown6.svg',
      'Dental_crown7.svg',
      'Dental_crown8.svg',
      'Dental_crown9.svg',
      'Dental_decay2.svg',
      'Dental_decay3.svg',
      'Dental_dentistchair1.svg',
      'Dental_dentistchair2.svg',
      'Dental_dentistchair3.svg',
      'Dental_dentistchair4.svg',
      'Dental_dentistchair6.svg',
      'Dental_dentistchair7.svg',
      'Dental_dentistfemale1.svg',
      'Dental_dentistfemale4.svg',
      'Dental_dentistmale1.svg',
      'Dental_dentistmale2.svg',
      'Dental_dentistmale3.svg',
      'Dental_dentistmale4.svg',
      'Dental_dentistmale5.svg',
      'Dental_dentistmale6.svg',
      'Dental_dentistmale7.svg',
      'Dental_dentistmale8.svg',
      'Dental_dentistry.svg',
      'Dental_dentures.svg',
      'Dental_drill1.svg',
      'Dental_drill2.svg',
      'Dental_drill3.svg',
      'Dental_drill4.svg',
      'Dental_drill5.svg',
      'Dental_drill6.svg',
      'Dental_drill7.svg',
      'Dental_drop.svg',
      'Dental_drugs4.svg',
      'Dental_drugs5.svg',
      'Dental_drugs6.svg',
      'Dental_drugs7.svg',
      'Dental_drugs8.svg',
      'Dental_enamel1.svg',
      'Dental_enamel2.svg',
      'Dental_endo.svg',
      'Dental_excavator.svg',
      'Dental_extraction1.svg',
      'Dental_extraction2.svg',
      'Dental_extraction3.svg',
      'Dental_extraction4.svg',
      'Dental_extraction5.svg',
      'Dental_extraction6.svg',
      'Dental_fairy.svg',
      'Dental_falseteeth.svg',
      'Dental_family.svg',
      'Dental_female.svg',
      'Dental_file.svg',
      'Dental_filling1.svg',
      'Dental_filling2.svg',
      'Dental_fixing.svg',
      'Dental_flashlight.svg',
      'Dental_floss1.svg',
      'Dental_floss2.svg',
      'Dental_floss3.svg',
      'Dental_floss4.svg',
      'Dental_floss5.svg',
      'Dental_floss6.svg',
      'Dental_floss7.svg',
      'Dental_floss8.svg',
      'Dental_fluoride.svg',
      'Dental_foamy.svg',
      'Dental_folder.svg',
      'Dental_forceps1.svg',
      'Dental_forceps2.svg',
      'Dental_forceps3.svg',
      'Dental_forum.svg',
      'Dental_freshener.svg',
      'Dental_gingivitis.svg',
      'Dental_global.svg',
      'Dental_gloves.svg',
      'Dental_gum.svg',
      'Dental_gun.svg',
      'Dental_health.svg',
      'Dental_heartbeat.svg',
      'Dental_hook1.svg',
      'Dental_hook2.svg',
      'Dental_hospital.svg',
      'Dental_hospital2.svg',
      'Dental_hygiene.svg',
      'Dental_implant1.svg',
      'Dental_implant2.svg',
      'Dental_implant3.svg',
      'Dental_implant4.svg',
      'Dental_implant5.svg',
      'Dental_implant6.svg',
      'Dental_incisor.svg',
      'Dental_irrigator1.svg',
      'Dental_irrigator2.svg',
      'Dental_irrigator3.svg',
      'Dental_lab.svg',
      'Dental_laptop.svg',
      'Dental_led.svg',
      'Dental_light.svg',
      'Dental_lips.svg',
      'Dental_location1.svg',
      'Dental_location2.svg',
      'Dental_location3.svg',
      'Dental_locationmap.svg',
      'Dental_mail.svg',
      'Dental_male2.svg',
      'Dental_mask.svg',
      'Dental_medical_assistance.svg',
      'Dental_message.svg',
      'Dental_mirror1.svg',
      'Dental_mirror2.svg',
      'Dental_mirror3.svg',
      'Dental_mirror4.svg',
      'Dental_mirror5.svg',
      'Dental_mobile1.svg',
      'Dental_mobile2.svg',
      'Dental_molar1.svg',
      'Dental_molar2.svg',
      'Dental_mouth2.svg',
      'Dental_mouth4.svg',
      'Dental_mouthwash1.svg',
      'Dental_mouthwash2.svg',
      'Dental_mouthwash3.svg',
      'Dental_mouthwash4.svg',
      'Dental_mouthwash5.svg',
      'Dental_mouthwash6.svg',
      'Dental_nochocolate.svg',
      'Dental_nofastfood.svg',
      'Dental_nosmoking.svg',
      'Dental_nosweet.svg',
      'Dental_note.svg',
      'Dental_notification.svg',
      'Dental_openmouth.svg',
      'Dental_ortho.svg',
      'Dental_pain.svg',
      'Dental_plaque.svg',
      'Dental_pliers.svg',
      'Dental_protection.svg',
      'Dental_protection4.svg',
      'Dental_protection5.svg',
      'Dental_record.svg',
      'Dental_record3.svg',
      'Dental_removal.svg',
      'Dental_removaltongs.svg',
      'Dental_report.svg',
      'Dental_report12.svg',
      'Dental_report4.svg',
      'Dental_report5.svg',
      'Dental_report7.svg',
      'Dental_root8.svg',
      'Dental_rootcanal.svg',
      'Dental_rootmetallic.svg',
      'Dental_rotten.svg',
      'Dental_scaler1.svg',
      'Dental_scaler2.svg',
      'Dental_scaler3.svg',
      'Dental_scaler4.svg',
      'Dental_scaler5.svg',
      'Dental_scaling.svg',
      'Dental_scan4.svg',
      'Dental_schedule.svg',
      'Dental_search1.svg',
      'Dental_search2.svg',
      'Dental_search3.svg',
      'Dental_search4.svg',
      'Dental_search5.svg',
      'Dental_search6.svg',
      'Dental_sensitive.svg',
      'Dental_settings1.svg',
      'Dental_settings2.svg',
      'Dental_settings3.svg',
      'Dental_sink1.svg',
      'Dental_sink2.svg',
      'Dental_sleep1.svg',
      'Dental_sleep2.svg',
      'Dental_smartwatch.svg',
      'Dental_smile1.svg',
      'Dental_smile2.svg',
      'Dental_smile3.svg',
      'Dental_smoking1.svg',
      'Dental_smoking2.svg',
      'Dental_stethoscope.svg',
      'Dental_submerge.svg',
      'Dental_suction.svg',
      'Dental_surgeon1.svg',
      'Dental_surgeon2.svg',
      'Dental_surgeon3.svg',
      'Dental_syringe1.svg',
      'Dental_syringe2.svg',
      'Dental_target.svg',
      'Dental_teeth1.svg',
      'Dental_teeth10.svg',
      'Dental_teeth11.svg',
      'Dental_teeth12.svg',
      'Dental_teeth13.svg',
      'Dental_teeth14.svg',
      'Dental_teeth15.svg',
      'Dental_teeth16.svg',
      'Dental_teeth17.svg',
      'Dental_teeth18.svg',
      'Dental_teeth19.svg',
      'Dental_teeth2.svg',
      'Dental_teeth3.svg',
      'Dental_teeth4.svg',
      'Dental_teeth5.svg',
      'Dental_teeth6.svg',
      'Dental_teeth7.svg',
      'Dental_teeth8.svg',
      'Dental_teeth9.svg',
      'Dental_teethbaby.svg',
      'Dental_teethdone.svg',
      'Dental_teethdrill.svg',
      'Dental_teethop.svg',
      'Dental_teethperio.svg',
      'Dental_tonguecleaner.svg',
      'Dental_tools1.svg',
      'Dental_tools2.svg',
      'Dental_tools3.svg',
      'Dental_tools4.svg',
      'Dental_tools5.svg',
      'Dental_tooth.svg',
      'Dental_toothache.svg',
      'Dental_toothache1.svg',
      'Dental_toothache3.svg',
      'Dental_toothbrush1.svg',
      'Dental_toothbrush10.svg',
      'Dental_toothbrush11.svg',
      'Dental_toothbrush12.svg',
      'Dental_toothbrush13.svg',
      'Dental_toothbrush2.svg',
      'Dental_toothbrush3.svg',
      'Dental_toothbrush4.svg',
      'Dental_toothbrush5.svg',
      'Dental_toothbrush6.svg',
      'Dental_toothbrush7.svg',
      'Dental_toothbrush8.svg',
      'Dental_toothbrush9.svg',
      'Dental_toothbrushelectric1.svg',
      'Dental_toothbrushelectric2.svg',
      'Dental_toothbrushelectric3.svg',
      'Dental_toothbrushelectric4.svg',
      'Dental_toothbrushing.svg',
      'Dental_toothpaste1.svg',
      'Dental_toothpaste2.svg',
      'Dental_toothpaste3.svg',
      'Dental_toothpaste4.svg',
      'Dental_toothpaste5.svg',
      'Dental_toothpaste6.svg',
      'Dental_toothpaste7.svg',
      'Dental_toothpick.svg',
      'Dental_toothwhitening.svg',
      'Dental_toothwisdom1.svg',
      'Dental_toothwisdom2.svg',
      'Dental_toothwisdom3.svg',
      'Dental_tweezers1.svg',
      'Dental_tweezers2.svg',
      'Dental_user.svg',
      'Dental_veneer1.svg',
      'Dental_veneer2.svg',
      'Dental_vitamins.svg',
      'Dental_webbrowser.svg',
      'Dental_whitening1.svg',
      'Dental_whitening2.svg',
      'Dental_whitening3.svg',
      'Dental_whiteteeth.svg',
      'Dental_xray1.svg',
      'Dental_xray2.svg',
      'Dental_xray3.svg',
      'Dental_xray4.svg',
      'dental_search7.svg'
    ]
  }
]

export default tagIcons
